import React, { forwardRef, useCallback, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import axios from "axios";

/*lineType Components*/
import "./LineType.css";
import LineTypeInfo from "./lineTypesComponents/LineTypeInfo";
import LineTypeList from "./lineTypesComponents/LineTypeList";
import LineTypeTabs from "./lineTypesComponents/LineTypeTabs";

const lineType = forwardRef((props) => {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [lineType, setlineType] = React.useState(0);

  let history = useHistory();

  const requestData = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/LineType/GetLineTypeInfo?idLineType=${props.match.params.id}`;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setlineType(data);
      }, 500);
  }, [props.match.params.id]);

  useEffect(() => {
    requestData();
  }, [requestData]);

  function UpdateLineType(row) {
    let lineTypeRequest = {
      IdLineType: row.idLineType,
      Description: row.description,
      MLBIncrease: row.mlbIncrease,
      NBAIncrease: row.nbaIncrease,
      NHLIncrease: row.nhlIncrease,
      FBBBSpreadSync: row.fbbbSpreadSync,
      FBBBSpreadOddsSync: row.fbbbSpreadOddsSync,
      FBBBTotalSync: row.fbbbTotalSync,
      FBBBTotalOddsSync: row.fbbbTotalOddsSync,
      FBBBMoneyLineSync: row.fbbbMoneyLineSync,
      MLBMoneyLineSync: row.mlbMoneyLineSync,
      MLBRunSync: row.mlbRunSync,
      MLBRunOddsSync: row.mlbRunOddsSync,
      MLBTotalSync: row.mlbTotalSync,
      MLBTotalOddsSync: row.mlbTotalOddsSync,
      MUSpreadSync: row.muSpreadSync,
      MUSpreadOddsSync: row.muSpreadOddsSync,
      MUTotalSync: row.muTotalSync,
      MUTotalOddsSync: row.muTotalOddsSync,
      MUMoneyLineSync: row.muMoneyLineSync,
      NHLAmericanSync: row.nhlAmericanSync,
      NHLAmericanOddsSync: row.nhlAmericanOddsSync,
      NHLCanadianSync: row.nhlCanadianSync,
      NHLCanadianOddsSync: row.nhlCanadianOddsSync,
      NHLMoneyLineSync: row.nhlMoneyLineSync,
      NHLTotalSync: row.nhlTotalSync,
      NHLTotalOddsSync: row.nhlTotalOddsSync,
      SOCGoalsSync: row.socGoalsSync,
      SOCGoalsOddsSync: row.socGoalsOddsSync,
      SOCMoneyLineSync: row.socMoneyLineSync,
      SOCTotalSync: row.socTotalSync,
      SOCTotalOddsSync: row.socTotalOddsSync,
      JuiceRebate_WebOnly: row.juiceRebate_WebOnly,
      DefaultOdds: row.defaultOdds,
      DefaultRebatePct: row.defaultRebatePct,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/LineType/LineType_Update",
      data: lineTypeRequest,
    }).then(() => {
      requestData();
    });
  }

  const setCurrentlineType = (lineType) => {
    setlineType(lineType);
    let anothervar = lineType.idLineType.toString();
    history.push(anothervar);
  };

  return (
    <React.Fragment>
      {lineType && (
        <>
          <div className="sticky top-0 flex-grow-0">
            <LineTypeList
              showLoading={props.showLoading}
              setLineType={setCurrentlineType}
            ></LineTypeList>
          </div>
          <div className="flex-1 pl-4 h-max">
            <Paper>
              <LineTypeInfo LineType={lineType}></LineTypeInfo>
              <LineTypeTabs
                AgentInfo={props.location}
                LineType={lineType}
                UpdateLineType={UpdateLineType}
                showLoading={props.showLoading}
              ></LineTypeTabs>
            </Paper>
          </div>
        </>
      )}
    </React.Fragment>
  );
});

export default lineType;
